import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { IApplicationState, IAppState } from '@nkr/store/index';

interface IStateProps {
    app: IAppState
}

interface IProps {
    path: string | string[],
    component?: any,
    render?: any;
    groups: number[],
    isMicrositeCoach?: boolean
}

type TProps = IProps & IStateProps;

const PrivateRoute = ({ component: Component = null, render: Render = null, app, groups, isMicrositeCoach, ...rest }: TProps) => {
    const isAuthenticated = (location) => {
        let retval = 1;

        if (!app.user) {
            return 2;
        }

        // check if route is restricted by role
        if (groups && groups.indexOf(app.user.group.id) === -1) {
            return 3;
        }

        if (isMicrositeCoach != undefined && isMicrositeCoach == true) {
            if (!app.user.isMicrositeCoach) {
                return 3;
            }
        }

        return retval;
    }

    return (
        <Route
            {...rest}
            render={props => {
                let auth = isAuthenticated(props.location);
                
                return (
                    auth == 1 ?
                        Render ? Render(props) : Component ? <Component {...props} /> : null
                        :
                        auth == 2 ?
                            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                            :
                            <Redirect to={{ pathname: '/not-authorized' }} />
                );
            }}
        />
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
};

export default connect<IStateProps, {}, IProps>(mapStateToProps, null)(PrivateRoute as any);
